import React, { Component } from "react";
import {
  Button,
  Col,
  FormControl,
  FormGroup,
  Nav,
  Row,
  TabContainer,
  TabContent,
  TabPane,
  Modal,
} from "react-bootstrap";

import { jsonHelper } from "../../../helpers";

import { TabNavItemCS, TabNavItemMada, TabNavItemINVC, TabNavItemKNET, TabNavItemWallet, TabNavItemON, TabNavItemVCHR, TabNavItemFT, TabNavItemCASH } from "./PaymentNavItem";
import { validator } from "./validator";

import "./index.scss";
import { ls } from "../../../locale";
import FormErrorBlock from "../../../components/FormErrorBlock";
import TermsCheckbox from "../../../components/Common/TermsCheckbox";

import { PaymentDesc } from "./PaymentDesc";
import { CsTabPane } from "./CsTabPane";
import { MadaTabPane } from "./MadaTabPane";
import { SectionTitle } from "../../../comps/section-title";

const defaultPaymentSettings = {
  ON: {
    error: {}
  },
  VCHR: {
    code: null,
    pin: null,
    error: {}
  },
  INVC: {
    error: {}
  },
  PL: {
    error: {}
  },
  CASH: {
    refNumber: '',
    error: {}
  }
}

export default class PaymentOptions extends Component {

  constructor(props) {
    super(props);

    this.csTabRef = React.createRef();
    this.madaTabRef = React.createRef();
    this.spTabRef = React.createRef();

    this.state = {
      terms: true,
      payments: jsonHelper.cloneDeep(defaultPaymentSettings),
      message: null,
      isShowMessageBox: false,
    };
  }

  resetCurrentPayment = () => {
    
    const method = this.props.paymentMethodCode;
    if(!method) return;

    if(method === 'CS') {
      if(this.csTabRef.current) this.csTabRef.current.reset();
    }
    else if(method === 'MADA') {
      if(this.madaTabRef.current) this.madaTabRef.current.reset();
    }
    // else if(method === 'SP') {
    //   if(this.spTabRef.current) this.spTabRef.current.reset();
    // }

    const methodDefaults = defaultPaymentSettings[method];
    if(methodDefaults) {
      this.setState({
        payments: {
          ...this.state.payments,
          [method]: jsonHelper.cloneDeep(methodDefaults)
        }
      })
    }
  }

  callApplyVoucher = () => {
    if (this.props.onApplyVoucher && typeof (this.props.onApplyVoucher) === 'function')
      this.props.onApplyVoucher();
  }

  setPaymentMethodState = code => {

    // if the payment option is disabled, then we don't fire the method change event
    if(this.props.disabled) return;

    if (this.props.onPaymentMethodChanged && typeof (this.props.onPaymentMethodChanged) === 'function')
      this.props.onPaymentMethodChanged(code);
  }

  toggleTermsState = () => {
    this.setState({
      terms: !this.state.terms
    });
  }

  clearPaymentErrorState = () => {
    if(this.csTabRef.current && typeof this.csTabRef.current.clearErrors === 'function') {
      this.csTabRef.current.clearErrors();
    }

    if(this.madaTabRef.current && typeof this.madaTabRef.current.clearErrors === 'function') {
      this.madaTabRef.current.clearErrors();
    }

    if(this.spTabRef.current && typeof this.spTabRef.current.clearErrors === 'function') {
      this.spTabRef.current.clearErrors();
    }

    this.setVoucherErrorState("code", null);
    this.setVoucherErrorState("pin", null);
  };

  setVoucherState = (field, value) => {
    const voucher = this.state.payments.VCHR;

    value = value.trim().toUpperCase();
    if(value.length > 6) value = value.substring(0, 6);
    voucher[field] = value;

    this.setState({
      payments: {...this.state.payments, VCHR: voucher }
    });
    this.setVoucherErrorState(field, null);
  };

  setVoucherErrorState = (field, value) => {
    const voucher = this.state.payments.VCHR;

    voucher.error[field] = value;
    this.setState({
      payments: {...this.state.payments, VCHR: voucher }
    });
  };

  setCashState = (field, value) => {
    const cash = this.state.payments.CASH;

    value = value.trim().toUpperCase();
    cash[field] = value;

    this.setState({
      payments: {...this.state.payments, CASH: cash }
    });
    this.setCashErrorState(field, null);
  };

  setCashErrorState = (field, value) => {
    const cash = this.state.payments.CASH;

    cash.error[field] = value;
    this.setState({
      payments: {...this.state.payments, CASH: cash }
    });
  };

  validateForm = () => {
    this.clearPaymentErrorState();
    const paymentMethodCode = this.props.paymentMethodCode;

    if (paymentMethodCode === "CS") {
      if(this.csTabRef.current && typeof this.csTabRef.current.validate === 'function') {
        return this.csTabRef.current.validate();
      }
      return false;
    }
    else if (paymentMethodCode === "MADA") {
      if(this.madaTabRef.current && typeof this.madaTabRef.current.validate === 'function') {
        return this.madaTabRef.current.validate();
      }
      return false;
    }
    else if (paymentMethodCode === "SP") {
      if(this.spTabRef.current && typeof this.spTabRef.current.validate === 'function') {
        return this.spTabRef.current.validate();
      }
      return false;
    }


    else if (paymentMethodCode === "VCHR") {
      const voucher = this.state.payments.VCHR;
      this.setVoucherErrorState("code", validator.validateVoucherCode(voucher.code));
      this.setVoucherErrorState("pin", validator.validateVoucherPin(voucher.pin));
    }
    else if(paymentMethodCode === 'CASH') {
      const cash = this.state.payments.CASH;
      this.setCashErrorState('refNumber', validator.validateRefNumber(cash.refNumber))
    }

    return this.isFormValid();
  }

  isFormValid = () => {
    const paymentMethodCode = this.props.paymentMethodCode;

    if (paymentMethodCode === "CS") {
      if(this.csTabRef.current && typeof this.csTabRef.current.isValid === 'function') {
        return this.csTabRef.current.isValid();
      }
      return false;
    }
    if (paymentMethodCode === "MADA") {
      if(this.madaTabRef.current && typeof this.madaTabRef.current.isValid === 'function') {
        return this.madaTabRef.current.isValid();
      }
      return false;
    }
    else if (paymentMethodCode === "VCHR") {
      const voucher = this.state.payments.VCHR;
      if (voucher.error.code || voucher.error.pin)
        return false;
    }
    else if(paymentMethodCode === 'CASH') {
      const cash = this.state.payments.CASH;
      if(cash.error.refNumber) return false;
    }

    return true;
  }

  getFormValues = () => {
    const paymentMethodCode = this.props.paymentMethodCode;

    let paymentValues;
    if(paymentMethodCode === 'CS') {
      paymentValues = this.csTabRef.current && typeof this.csTabRef.current.getValues === 'function'
        ? this.csTabRef.current.getValues()
        : {};
    }
    else if(paymentMethodCode === 'MADA') {
      paymentValues = this.madaTabRef.current && typeof this.madaTabRef.current.getValues === 'function'
        ? this.madaTabRef.current.getValues()
        : {};
    }
    // else if(paymentMethodCode === 'SP') {
    //   paymentValues = this.spTabRef.current && typeof this.spTabRef.current.getValues === 'function'
    //     ? this.spTabRef.current.getValues()
    //     : {};
    // }
    else {
      paymentValues = this.state.payments[paymentMethodCode];
    }

    const result = {
      paymentMethodCode,
      ...(paymentValues || {})
    }

    if(result.cardNumber) 
      result.cardNumber = result.cardNumber.replace(/\s/g, '')

    return result
  }

  getTermsState = () => {
    return this.state.terms;
  }

  closeMessageBox = () => {
    this.setState({
      isShowMessageBox: false,
      message: null
    });
  };

  showMessageBox = (message, title) => {
    this.setState({
      isShowMessageBox: true,
      message: message,
      messageTitle: title
    });
  };

  stayOnCyberSource = () => {
   this.closeMessageBox();
   if(this.csTabRef.current && typeof this.csTabRef.current.setCardNumber === 'function') {
     this.csTabRef.current.setCardNumber('');
   }
  }

  contiueWithOmanNet = () => {
    this.closeMessageBox();
    if(this.csTabRef.current && typeof this.csTabRef.current.setCardNumber === 'function') {
      this.csTabRef.current.setCardNumber('');
    }
    this.setPaymentMethodState('ON');
  }

  render() {

    const rPayment = ls.t('Payment');
    if(!rPayment.PaymentOptions) return null;

    const methods = this.props.paymentMethods;
    if(!Array.isArray(methods) || !methods.length) return null;

    const rButton = ls.t('Button');
    const rMessageBox = ls.t('MessageBox');

    const {paymentMethodCode, paymentStatus, voucherApplied, eppEligible } = this.props;
    const autoCompleteSeed = new Date().getMilliseconds();

    const agencyInfo = this.props.userData || {currencyCode: 'OMR', availableCredit: 0};
    // const lastAttemptedPayment = this.props.lastAttemptedPayment;
  
    return (
      <React.Fragment>
        <SectionTitle title={rPayment.PaymentOptions} />

        <div className={ "payment-options" + (this.props.className ? ' ' + this.props.className : '') }>          

          {this.props.statement && <TermsCheckbox 
            checked={this.state.terms === true} 
            onClick={() => this.toggleTermsState()} 
            terms={this.props.statement} />}
          <TabContainer id="payment-options" activeKey={paymentMethodCode} defaultActiveKey="CS" onSelect={() => { } }>
            <div className="tab-wrapper clearfix">
              <Col md={6} className="panel-box">
                <Nav bsStyle="pills" stacked className={ls.t('rootClass')}>
                  {methods.map((method) => { switch(method) {
                    // case 'SPW': return lastAttemptedPayment === 'CS' ? null : <TabNavItemWallet key={method} paymentMethodCode={paymentMethodCode} setPaymentMethodState={this.setPaymentMethodState} />
                    case 'SPW': return <TabNavItemWallet key={method} paymentMethodCode={paymentMethodCode} setPaymentMethodState={this.setPaymentMethodState} />
                    case 'ON': return <TabNavItemON key={method} paymentMethodCode={paymentMethodCode} setPaymentMethodState={this.setPaymentMethodState} />
                    case 'KNET': return <TabNavItemKNET key={method} paymentMethodCode={paymentMethodCode} setPaymentMethodState={this.setPaymentMethodState} />
                    // case 'SP': return <TabNavItemSP key={method} paymentMethodCode={paymentMethodCode} setPaymentMethodState={this.setPaymentMethodState} />
                    case 'CS': return <TabNavItemCS key={method} paymentMethodCode={paymentMethodCode} setPaymentMethodState={this.setPaymentMethodState} />
                    case 'MADA': return <TabNavItemMada key={method} paymentMethodCode={paymentMethodCode} setPaymentMethodState={this.setPaymentMethodState} />
                    case 'VCHR': return (!paymentStatus || voucherApplied) 
                                ? <TabNavItemVCHR key={method} paymentMethodCode={paymentMethodCode} setPaymentMethodState={this.setPaymentMethodState} />
                                : false;
                    case 'INVC': return <TabNavItemINVC key={method} paymentMethodCode={paymentMethodCode} setPaymentMethodState={this.setPaymentMethodState} />
                    // case 'PL': return <TabNavItemPL key={method} paymentMethodCode={paymentMethodCode} setPaymentMethodState={this.setPaymentMethodState} />
                    case 'FT': return <TabNavItemFT key={method} paymentMethodCode={paymentMethodCode} setPaymentMethodState={this.setPaymentMethodState} />
                    case 'CASH': return <TabNavItemCASH key={method} paymentMethodCode={paymentMethodCode} setPaymentMethodState={this.setPaymentMethodState} />
                    default: return false;
                  }})}
                </Nav>
              </Col>
              <Col md={6} className="panel-box">
                <TabContent animation>
                  {/* { lastAttemptedPayment !== 'CS' && methods.find(x => x === 'SPW') && <TabPane eventKey="SPW"> */}
                  { methods.find(x => x === 'SPW') && <TabPane eventKey="SPW">
                    <Row className="credit-cards">
                      <Col md={12}>
                        <PaymentDesc text={rPayment.ApplePay.Desc} />
                      </Col>
                    </Row>
                  </TabPane>}
                  {methods.find(x => x === 'CS') && <TabPane eventKey="CS">
                    <CsTabPane
                      ref={this.csTabRef}
                      localDebitBins={this.props.localDebitBins}
                      onCreditCardNumberChange={this.props.onCreditCardNumberChange}
                      eppEligible={eppEligible}
                      onEppSelectionChange={this.props.onEppSelectionChange}
                    />
                  </TabPane>}
                  {methods.find(x => x === 'MADA') && <TabPane eventKey="MADA">
                    <MadaTabPane
                      ref={this.madaTabRef}
                      localDebitBins={this.props.localDebitBins}
                    />
                  </TabPane>}
                  {methods.find(x => x === 'ON') && <TabPane eventKey="ON">
                    <Row className="credit-cards">
                      <Col md={12}>
                        <PaymentDesc text={rPayment.OmanNet.Desc} />
                      </Col>
                    </Row>
                  </TabPane>}
                  {methods.find(x => x === 'KNET') && <TabPane eventKey="KNET">
                    <Row className="credit-cards">
                      <Col md={12}>
                        <PaymentDesc text={rPayment.Knet.Desc} />
                      </Col>
                    </Row>
                  </TabPane>}
                  {/* <TabPane eventKey="SP">
                    <CsTabPane
                      ref={this.spTabRef}
                      localDebitBins={this.props.localDebitBins}
                    />
                  </TabPane> */}
                  {methods.find(x => x === 'INVC') && <TabPane eventKey="INVC">
                    <Row className="credit-cards">
                      <Col md={12}>
                        <PaymentDesc text={rPayment.AGPay.Desc} />
                        <p>Available Credit: <strong>{agencyInfo.currencyCode} {agencyInfo.availableCredit}</strong></p>
                      </Col>
                    </Row>
                  </TabPane>}
                  {/* {methods.find(x => x === 'PL') && <TabPane eventKey="PL">
                    <Row className="credit-cards">
                      <Col md={12}>
                      {payLaterDesc.map((m, index) => <p key={index}>{m}</p>)}
                      </Col>
                    </Row>
                  </TabPane>} */}
                  {methods.find(x => x === 'FT') && <TabPane eventKey="FT">
                    <Row className="credit-cards">
                      <Col md={12}>
                        <PaymentDesc text={"Free ticket for staff."} />
                      </Col>
                    </Row>
                  </TabPane>}
                  {
                    methods.find(x => x === 'VCHR') && (!paymentStatus || voucherApplied) && <TabPane eventKey="VCHR">
                      {/* {
                        voucherApplied
                          ? <Row className="credit-cards">
                            <Col md={12}>
                              <p>{rPayment.Voucher.AppliedMessage}</p>
                            </Col>
                          </Row> : */}                           
                          <Row className="credit-cards">
                            <Col md={6}>
                              <FormGroup className={this.state.payments.VCHR.error.code ? "has-error" : null}>
                                <FormControl
                                  type="text"
                                  placeholder={rPayment.Voucher.Code}
                                  value={this.state.payments.VCHR.code || ""}
                                  autoComplete={autoCompleteSeed}
                                  onChange={event => this.setVoucherState("code", event.target.value)}
                                />
                                <FormErrorBlock error={this.state.payments.VCHR.error.code}/>
                              </FormGroup>
                            </Col>
                            <Col md={6}>
                              <FormGroup className={this.state.payments.VCHR.error.pin ? "has-error" : null}>
                                <FormControl
                                  type="text"
                                  placeholder={rPayment.Voucher.Pin}
                                  value={this.state.payments.VCHR.pin || ""}
                                  autoComplete={autoCompleteSeed}
                                  onChange={event => this.setVoucherState("pin", event.target.value)}
                                />
                                <FormErrorBlock error={this.state.payments.VCHR.error.pin} />
                              </FormGroup>
                              {!this.props.disabled && <div className="btnCon">
                                <Button className="btn btn-submit pull-right"
                                  onClick={() => this.callApplyVoucher()}>{rButton.Apply}</Button>
                              </div>}
                            </Col>
                          </Row>
                      {/* } */}
                    </TabPane>
                  }
                  {methods.find(x => x === 'CASH') && <TabPane eventKey="CASH">
                    <Row className="credit-cards">
                      <Col md={8}>
                        <FormGroup className={this.state.payments.CASH.error.refNumber ? "has-error" : null}>
                          <FormControl
                            type="text"
                            placeholder="Reference Number"
                            value={this.state.payments.CASH.refNumber || ""}
                            autoComplete={autoCompleteSeed}
                            onChange={event => this.setCashState("refNumber", event.target.value)}
                          />
                          <FormErrorBlock error={this.state.payments.CASH.error.refNumber}/>
                        </FormGroup>
                      </Col>
                    </Row>
                  </TabPane>}
                </TabContent>
              </Col>
            </div>
          </TabContainer>
        </div>
        <Modal className={ls.t("rootClass")} show={this.state.isShowMessageBox} >
          <Modal.Header>
            <Modal.Title>{this.state.messageTitle || rMessageBox.Title.Notification}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h4>{this.state.message}</h4>
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-secondary pull-left" onClick={this.stayOnCyberSource}>{rButton.Cancel}</button>
            <button className="btn btn-default" onClick={this.contiueWithOmanNet}>{rButton.ContinueWithOmanNet}</button>
          </Modal.Footer>
        </Modal>
      </React.Fragment>
    );
  }
}
